import { render, staticRenderFns } from "./Points.vue?vue&type=template&id=508f8429&scoped=true"
import script from "./Points.vue?vue&type=script&lang=ts"
export * from "./Points.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508f8429",
  null
  
)

export default component.exports